"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    FolderImageSolid: function() {
        return FolderImageSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const FolderImageSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M1 6C1 4.34315 2.34315 3 4 3H8.39445C8.98672 3 9.56575 3.17531 10.0585 3.50385L12.0509 4.83205C12.2151 4.94156 12.4081 5 12.6056 5H20C21.6569 5 23 6.34315 23 8V18C23 19.6569 21.6569 21 20 21H4C2.34315 21 1 19.6569 1 18V6ZM17.1447 10.2822C17.5115 9.90204 18.1108 9.87277 18.5129 10.2154L20.6486 12.0351C20.8716 12.2251 21 12.5033 21 12.7963V18C21 18.5523 20.5523 19 20 19H7.9805C7.57684 19 7.21277 18.7573 7.05747 18.3847C6.90217 18.0122 6.9861 17.5827 7.27026 17.296L11.2581 13.2726C11.6271 12.9003 12.2209 12.8761 12.619 13.2171L13.5464 14.0117L17.1447 10.2822ZM7.5 7C6.11929 7 5 8.11929 5 9.5C5 10.8807 6.11929 12 7.5 12C8.88071 12 10 10.8807 10 9.5C10 8.11929 8.88071 7 7.5 7Z",
        fill: "currentColor"
    })
}), "FolderImageSolid");
const _default = FolderImageSolid;
